import React from 'react';
import { View } from 'react-native';
import { Text } from '~/components';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';
import { GENERAL_CONDITIONS_LINK } from '../../constants';
import {
  ASSURANT_WEBSITE,
  INCOME_PROTECTION_ACCESSION_TERMS_LINK,
} from '~/utils/url';

interface Props {
  className?: string;
}

const GeneralInfoFooter: React.FC<Props> = ({ className }) => {
  return (
    <View className={className}>
      {!MarisaAppUtils.isTotem() && (
        <Text className="text-xs text-gray-400 text-center">
          Este seguro é administrado pela{' '}
          <Text
            className="text-primary-600 text-xs font-medium"
            onPress={() => MarisaAppUtils.openUrl(ASSURANT_WEBSITE)}
          >
            Assurant
          </Text>
          .
        </Text>
      )}
      <Text className="text-xs text-gray-400 text-center">
        Condições gerais do Proteção Perda de Renda:{' '}
        <Text
          className="text-primary-600 text-xs font-medium"
          onPress={() => MarisaAppUtils.openUrl(GENERAL_CONDITIONS_LINK)}
        >
          Consulte
        </Text>
      </Text>
      <Text className="text-xs text-gray-400 text-center">
        Termos de adesão:{' '}
        <Text
          className="text-primary-600 text-xs font-medium"
          onPress={() =>
            MarisaAppUtils.openUrl(INCOME_PROTECTION_ACCESSION_TERMS_LINK)
          }
        >
          Consulte aqui
        </Text>
      </Text>
    </View>
  );
};

export default GeneralInfoFooter;
